module.exports = __webpack_public_path__ + "media/images/subject_img/VETERINARY SCIENCE-d98d68df6a708476df79e0e9e4848f08.jpg";